import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { inject, observer } from 'mobx-react';
import styled from '@emotion/styled';
import * as DataList from 'components/DataList';
import WorkOrderEditor from 'components/DocEditor/WorkOrderEditor';
import { DocSkeleton } from 'components/DocEditor/DocSkeleton';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

// A work order (/dashboard/work-reports/:id/show): components/DocEditor.
@inject('workReportStore', 'viewStore') @observer
class WorkReportShowPage extends Component {

  retry = () => {
    const uuid = window.location.pathname.split('/').filter(Boolean).slice(-2)[0];
    this.props.workReportStore.loadWorkReport({ uuid });
  };

  // A work order that doesn't exist (deleted, or a wrong link) gets a way
  // back; anything else (offline, server error) gets Try again.
  renderError() {
    const { workReportStore: { workReport }, viewStore } = this.props;
    const missing = workReport.errorStatus === 404 || workReport.errorStatus === 403;
    const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
    const back = { label: 'Back to work orders', icon: 'arrow-left', onClick: () => viewStore.workReports() };
    return (
      <div className="cp-error">
        {missing ? (
          <DataList.Notice
            icon="clipboard"
            title="This work order isn't here"
            message="It may have been deleted, or the link may be wrong. Find it in your work orders instead."
            actions={[{ ...back, primary: true }]}
          />
        ) : (
          <DataList.Notice
            tone="error"
            icon={offline ? 'offline' : 'error'}
            role="alert"
            title="The work order couldn't be loaded"
            message={offline ? "You're offline. Reconnect, then try again." : 'Something went wrong on our side. Try again in a moment.'}
            actions={[{ label: 'Try again', icon: 'refresh', onClick: this.retry, primary: true }, back]}
          />
        )}
      </div>
    );
  }

  render() {
    const { workReportStore: { workReport: { isLoading, isError, object, errorStatus } } } = this.props;
    let content;
    let title;
    // Once shown, the work order stays on screen while it saves or reloads.
    if (object && object.id && object.attributes) {
      title = `${object.attributes.number} work order | Field Nexus`;
      content = <WorkOrderEditor key={object.id} />;
    } else if (isError && !isLoading) {
      title = `${errorStatus === 404 ? 'Work order not found' : "Couldn't load work order"} | Field Nexus`;
      content = this.renderError();
    } else {
      title = 'Loading..';
      content = <DocSkeleton noun="work order" />;
    }
    return (
      <div>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <PageWrapGray>
          {content}
        </PageWrapGray>
      </div>
    );
  }
}

export default WorkReportShowPage;
